import { useLangContext } from '../../../../providers/LangProvider/LangProviderContext';
import {
    UserStatusCongratulationsBenefitsPromocodeInfoBadgeStyled,
} from './styled/UserStatusCongratulationsBenefitsPromocodeInfoStyled';
import BinIcon from '../../../../components/icon/IconWrapped';
import UserStatusCongratulationsBenefitsCard from './UserStatusCongratulationsBenefitsCard';
import amountFormat from '../../../../utils/amountFormat';
import { getUserStatusParamsSelector } from '../../../../app/userSelectors';
import { useSelector } from 'react-redux';

function UserStatusCongratulationsBenefitsPromocodeInfo() {
    const { getLangPath } = useLangContext();
    const userStatusParams = useSelector(getUserStatusParamsSelector);

    return <UserStatusCongratulationsBenefitsCard
        badgeComponent={<UserStatusCongratulationsBenefitsPromocodeInfoBadgeStyled>
            +{amountFormat(userStatusParams?.giftPromocodeInfo?.amount, 0)}
            {userStatusParams?.giftPromocodeInfo?.amount_type === 'percent' ? '%' : ''}
            <BinIcon name={'IcGift'}/>
        </UserStatusCongratulationsBenefitsPromocodeInfoBadgeStyled>}
    >
        <span
            className={'text-secondary f14 text-start'}
            dangerouslySetInnerHTML={{ __html: getLangPath('user_statuses.promocode.deposit_bonus') }}
        />
    </UserStatusCongratulationsBenefitsCard>;
}

export default UserStatusCongratulationsBenefitsPromocodeInfo;
